<div class="content" role="main">
  @if (showNavbar() && loaded()) {
    <div class="height-saver"></div>
  }
  @if (showNavbar() && loaded()) {
    <mat-toolbar>
      <div class="toolbar-content">
        <div class="menu-container">
          @if (menuItemsCount() > 0) {
            <div #toggleButton>
              <button
                mat-icon-button
                [attr.aria-label]="menuExpanded() ? 'Menu sluiten' : 'Menu openen'"
                [attr.aria-expanded]="menuExpanded()"
                aria-controls="main-sidenav"
                (click)="sidenav.toggle()"
              >
                <mat-icon>menu</mat-icon>
              </button>
            </div>
          }
          @if (dataStore.selectedOrganisation) {
            <div class="org-menu-wrapper" #orgDropdown>
              <button
                mat-button
                [matMenuTriggerFor]="dataStore.isMemberOfMultipleOrgs ? orgMenu : ''"
                [disabled]="!dataStore.isMemberOfMultipleOrgs"
                class="menu-button"
                (menuOpened)="updateWidth('org', orgDropdown)"
              >
                <div class="menu-item-info">
                  @if (dataStore.selectedOrganisation.name) {
                    <div class="avatar-placeholder">
                      {{ dataStore.selectedOrganisation.name[0] }}
                    </div>
                  }
                  @if (dataStore.selectedOrganisation.name) {
                    <p class="menu-text">
                      {{ dataStore.selectedOrganisation.name }}
                    </p>
                  }
                  @if (dataStore.isMemberOfMultipleOrgs) {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  }
                </div>
              </button>
            </div>
            <mat-menu #orgMenu="matMenu" [overlapTrigger]="false">
              @for (org of dataStore.rootUser.organisations; track org.id) {
                @if (org.roles?.length > 0) {
                  <button
                    (click)="setOrganisation(org.id)"
                    class="menu-button"
                    mat-menu-item
                    [style.min-width]="orgWidth()"
                  >
                    <div class="button-wrapper">
                      <div class="avatar-placeholder small-placeholder">
                        {{ org.name[0] }}
                      </div>
                      <span>{{ org.name }}</span>
                    </div>
                  </button>
                }
              }
            </mat-menu>
          }
        </div>
        <div class="menu-container" #profileDropdown>
          @if (showNavbar() && loaded() && dataStore.paidFunctionalities.usesAIChat) {
            <button mat-icon-button class="help-button" aria-label="Help" matTooltip="Hulp" (click)="openHelpDialog()">
              <mat-icon>question_mark</mat-icon>
            </button>
          }
          <button
            mat-button
            [matMenuTriggerFor]="userMenu"
            class="menu-button"
            (menuOpened)="updateWidth('profile', profileDropdown)"
          >
            <div class="menu-item-info">
              @if (dataStore.orgUser?.email) {
                <div class="avatar-placeholder avatar-user">
                  {{ dataStore.orgUser.email[0] }}
                </div>
              }
              @if (dataStore.orgUser?.email) {
                <p class="menu-text">
                  {{ dataStore.orgUser.email }}
                </p>
              }
              <mat-icon>keyboard_arrow_down</mat-icon>
            </div>
          </button>
          <mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="profile-menu">
            @for (button of profileButtons(); track button.name) {
              <button mat-menu-item class="menu-button" (click)="button.action()" [style.min-width]="profileWidth()">
                <div class="button-wrapper">
                  <mat-icon>{{ button.icon }}</mat-icon>
                  <span>{{ button.name }}</span>
                </div>
              </button>
            }
          </mat-menu>
        </div>
      </div>
    </mat-toolbar>
  }

  @if (showNavbar() && loaded() && menuItemsCount() > 0) {
    <mat-sidenav-container [class.sidenav-backdrop]="sidenav.opened" [hasBackdrop]="true">
      <mat-sidenav
        #sidenav
        id="main-sidenav"
        mode="side"
        closed
        class="sidenav"
        (openedChange)="menuExpanded.set($event)"
        [fixedInViewport]="true"
        [fixedTopGap]="63"
        [fixedBottomGap]="0"
      >
        <div #menu class="side-nav">
          <div class="side-nav-content" (click)="sidenav.close()">
            @for (group of menuGroups(); track group.title) {
              <div class="content-group">
                <p class="content-group-title">{{ group.title }}</p>
                <div mat-nav-item class="menu-button-wrapper">
                  @for (item of group.items; track item.link) {
                    <button class="menu-button" mat-button [routerLink]="item.link">
                      <mat-icon>{{ item.icon }}</mat-icon>
                      <span>{{ item.name }}</span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </mat-sidenav>
    </mat-sidenav-container>
  }
  @if (loaded()) {
    <router-outlet></router-outlet>
  }

  @if (showHelpPane()) {
    <app-help-dialog (close)="showHelpPane.set(false)"></app-help-dialog>
  }

  @if (!loaded()) {
    <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }
</div>
